(function(){
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = window.Shopify && Shopify.designMode;
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function(){
    var docEl=document.documentElement;
    window.addEventListener('scroll',function(){ docEl.classList.toggle('hab-scrolled', window.scrollY>40); },{passive:true});
    var hh=document.querySelector('.banner__heading'); if((rm || !window.gsap) && hh && !hh.querySelector('.hab-hero-rule')){ var rr=document.createElement('span'); rr.className='hab-hero-rule'; rr.setAttribute('aria-hidden','true'); hh.appendChild(rr); }
    if(rm || !window.gsap) return;
    var gsap=window.gsap; if(window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger);
    /* smooth scroll (desktop only, native on touch) */
    if(!editor && window.Lenis && !('ontouchstart' in window)){
      var lenis=new Lenis({lerp:0.085, wheelMultiplier:0.95, anchors:true, allowNestedScroll:true});
      window.habLenis=lenis;
      lenis.on('scroll', function(){ window.ScrollTrigger && ScrollTrigger.update(); });
      gsap.ticker.add(function(t){ lenis.raf(t*1000); }); gsap.ticker.lagSmoothing(0);
      document.querySelectorAll('.menu-drawer, .drawer__inner, .cart-drawer, details-modal, .predictive-search, .localization-form__list').forEach(function(el){ el.setAttribute('data-lenis-prevent',''); });
    }
    var ease='power3.out';
    /* hero */
    var h=document.querySelector('.banner__heading');
    if(h && !h.dataset.habSplit){
      var txt=h.textContent.trim(); h.dataset.habSplit='1'; h.setAttribute('aria-label',txt);
      var target=h.querySelector('strong')||h; target.innerHTML='<span class="hab-split" dir="auto" aria-hidden="true">'+txt.split(' ').map(function(w){ return '<span class="hab-word">'+w.split('').map(function(c){ return '<span class="hab-ch">'+c+'</span>'; }).join('')+'</span>'; }).join(' ')+'</span>';
      gsap.from(h.querySelectorAll('.hab-ch'),{yPercent:110,opacity:0,duration:1.1,ease:'expo.out',stagger:0.045,delay:0.15});
      var rule=document.createElement('span'); rule.className='hab-hero-rule'; rule.setAttribute('aria-hidden','true'); h.appendChild(rule);
      gsap.fromTo(rule,{scaleX:0},{scaleX:1,duration:1.4,ease:'power3.inOut',delay:0.55});
      gsap.from('.banner__buttons, .banner__text',{y:24,opacity:0,duration:1,ease:ease,delay:0.7,stagger:0.12});
      var img=document.querySelector('.banner__media img');
      if(img){ gsap.fromTo(img,{scale:1.12},{scale:1,duration:2.4,ease:'power2.out'});
        if(window.ScrollTrigger) gsap.to(img,{yPercent:12,ease:'none',scrollTrigger:{trigger:img.closest('.banner')||img,start:'top top',end:'bottom top',scrub:true}}); }
    }
    if(!window.ScrollTrigger) return;
    /* section titles with drawing gold rule */
    document.querySelectorAll('.collection-list-title, .title-wrapper-with-link h2, .multicolumn h2.title, .featured-collection h2.title, .collection-hero__title, .main-page-title, .rich-text__heading').forEach(function(t){
      t.classList.add('hab-title'); t.style.setProperty('--hab-line',0);
      gsap.timeline({scrollTrigger:{trigger:t,start:'top 88%',once:true}})
        .from(t,{y:22,opacity:0,duration:.9,ease:ease})
        .to(t,{'--hab-line':1,duration:1.1,ease:'power2.inOut'},'-=.5');
    });
    /* cards & columns: staggered reveal with soft image unmask */
    var sel='.grid__item .card-wrapper, .collection-list__item, .multicolumn-list__item, .product__media-item, .article-card-wrapper';
    var items=gsap.utils.toArray(sel);
    gsap.set(items,{autoAlpha:0,y:36});
    ScrollTrigger.batch(items,{start:'top 92%',once:true,onEnter:function(b){
      gsap.to(b,{autoAlpha:1,y:0,duration:1,ease:ease,stagger:0.09,overwrite:true});
      b.forEach(function(el){ var im=el.querySelector('.card__media img, .media img'); if(im) gsap.fromTo(im,{clipPath:'inset(12% 0 0 0)'},{clipPath:'inset(0% 0 0 0)',duration:1.2,ease:'power2.out'}); });
    }});
    /* rich text / product info */
    gsap.utils.toArray('.rich-text__blocks > *, .product__info-container > *').forEach(function(el,i){
      gsap.from(el,{y:18,opacity:0,duration:.8,ease:ease,delay:Math.min(i*0.05,.4),scrollTrigger:{trigger:el,start:'top 92%',once:true}});
    });
    window.addEventListener('load',function(){ ScrollTrigger.refresh(); });
  });
})();